import { render, staticRenderFns } from "./DoseRecommendationTab.vue?vue&type=template&id=2c2e1cf6&scoped=true"
import script from "./DoseRecommendationTab.vue?vue&type=script&lang=js"
export * from "./DoseRecommendationTab.vue?vue&type=script&lang=js"
import style0 from "./DoseRecommendationTab.vue?vue&type=style&index=0&id=2c2e1cf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2e1cf6",
  null
  
)

export default component.exports